module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "trans"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pvii"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0006#toc"
    }
  }, [_vm._v("NOTE ON TRANSLATIONS AND MUSICAL EXAMPLES")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "data-locator": "pvii"
    }
  }), _vm._v("Given the burgeoning online availability of so many historical sources from the seventeenth and eighteenth centuries, and in order to make the present book somewhat shorter and more pleasurable to read, I have generally dispensed with the German-language quotations, except for poetic texts (e.g., chorales and arias), where the nuances of meaning and interpretation are significant. I have similarly not included the original when it is easily legible in one of the figures, as is the case for the engravings from Weigel’s "), _c('i', [_vm._v("Musicalisches Theatrum")]), _vm._v(". All translations are mine unless otherwise indicated.")]), _vm._v(" "), _c('p', [_vm._v("For those interested in checking the original passages relating directly to the Bach family, these are collected in the first three volumes of "), _c('i', [_vm._v("Bach-Dokumente")]), _vm._v(" (see the bibliography). Many of the music treatises, such as those by Johann Mattheson cited throughout and Martin Fuhrmann’s "), _c('i', [_vm._v("Musicalischer Trichter")]), _vm._v(" quoted at length in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0013#ch02"
    }
  }, [_vm._v("chapter 2")]), _vm._v(", are available through the International Music Score Library Project (IMSLP) site and elsewhere; periodicals such as "), _c('i', [_vm._v("Die Zeitschrift für Musik")]), _vm._v(" and "), _c('i', [_vm._v("Musik im Kriege")]), _vm._v(" investigated in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiyearsley0012#ch01"
    }
  }, [_vm._v("chapter 1")]), _vm._v(" can be read on the Internet Archive ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://archive.org",
      "target": "_blank"
    }
  }, [_vm._v("archive.org")]), _vm._v("); many of the theological sources and other reference works such as Zedler’s "), _c('i', [_vm._v("Universal-Lexicon")]), _vm._v(" and Corvinus’s "), _c('i', [_vm._v("Frauenzimmer-Lexicon")]), _vm._v(" can be consulted through the Herzog August Bibliothek Wolfenbüttel and the Bayerische Staatsbibliothek digitization projects (some of them jointly undertaken) and Google Books, among other such constantly expanding and proliferating "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "pviii"
    }
  }), _vm._v("initiatives. I have occasionally included crucial German words within my English translations.")]), _vm._v(" "), _c('p', [_vm._v("The musical examples from Anna Magdalena Bach’s Notebooks (and the Kuhnau "), _c('i', [_vm._v("Biblical Sonata")]), _vm._v(") presented here in modern notation are based directly on the originals. Most of the excerpts from Johann Sebastian Bach’s vocal works draw on the Bach-Gesellschaft edition and the "), _c('i', [_vm._v("Neue Bach-Ausgabe")]), _vm._v("; the material from "), _c('i', [_vm._v("O angenehme Melodei")]), _vm._v(" (BWV 210a), "), _c('i', [_vm._v("Vergnügte Pleißenstadt")]), _vm._v(" (BWV 216), and "), _c('i', [_vm._v("Klagt, Kinder, klagt es aller Welt")]), _vm._v(" (BWV 244a), however, rely on the reconstructions of these works prepared by Alexander Grychtolik (see the bibliography). In general, musical examples have been included when I attempt detailed readings of the passages as they relate to Anna Magdalena Bach’s activities as a performer, among other topics considered in this study, and where modern typography makes the texts more legible. Otherwise I have mostly chosen to include facsimile pages from the Notebooks as figures.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a30ce02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-yearsley-0007.vue
// module id = 72
// module chunks = 0